import AbstractChannel from './AbstractChannel'

export default class SnagASpace extends AbstractChannel {

  name = 'snagaspace'
  title = 'Snag-A-Space'
  titleShort = 'Snag-A-Space'
  color = '#393b79'

  supportedFeatures = ['blackouts']

}
